var _excluded = ["id"];

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

import * as React from "react";
import StackView from "../StackView";
import Toast from "./Toast";
import toaster from "./toaster";
import { jsx as ___EmotionJSX } from "@emotion/core";
var idCounter = 1;

function useToasts() {
  var _React$useState = React.useState([]),
      toasts = _React$useState[0],
      setToasts = _React$useState[1];

  function createToastInstance(title, settings) {
    if (settings === void 0) {
      settings = {};
    } // eslint-disable-next-line no-plusplus


    var uniqueId = ++idCounter;
    var id = settings.id == null ? uniqueId : settings.id + "-" + uniqueId;
    return {
      id: id,
      intent: settings.intent,
      title: title,
      description: settings.description,
      hasCloseButton: settings.hasCloseButton == null ? true : settings.hasCloseButton,
      duration: settings.duration || 5
    };
  }
  /**
   * This will set isShown on the Toast which will close the toast.
   * It won't remove the toast until the onExited transition event
   * triggers onRemove.
   */


  function closeToast(id) {
    setToasts(function (previousToasts) {
      return previousToasts.map(function (toast) {
        if (toast.id === id) {
          return _extends({}, toast, {
            isShown: false
          });
        }

        return toast;
      });
    });
  }

  function closeAll() {
    toasts.forEach(function (toast) {
      return closeToast(toast.id);
    });
    return toasts;
  }

  function removeToast(id) {
    setToasts(function (previousToasts) {
      return previousToasts.filter(function (toast) {
        return toast.id !== id;
      });
    });
  }

  function notify(title, settings) {
    if (settings === void 0) {
      settings = {};
    } // If there's a custom toast ID passed, close existing toasts with the
    // same custom ID


    if (settings.id != null) {
      toasts.forEach(function (toast) {
        // Since unique ID is still appended to a custom ID,
        // skip the unique ID and check only prefix
        if (String(toast.id).startsWith(String(settings.id))) {
          closeToast(toast.id);
        }
      });
    }

    var instance = createToastInstance(title, settings);
    setToasts(function (previousToasts) {
      return [instance].concat(previousToasts);
    });
    return instance;
  }

  return {
    toasts: toasts,
    closeAll: closeAll,
    notify: notify,
    closeToast: closeToast,
    removeToast: removeToast
  };
}

export default function ToastManager() {
  var _useToasts = useToasts(),
      toasts = _useToasts.toasts,
      closeAll = _useToasts.closeAll,
      notify = _useToasts.notify,
      closeToast = _useToasts.closeToast,
      removeToast = _useToasts.removeToast;

  React.useEffect(function () {
    toaster.toastManager = {
      closeAll: closeAll,
      notify: notify
    };
    return function () {
      toaster.toastManager = null;
    };
  });
  return ___EmotionJSX(StackView, {
    spacing: "sm",
    paddingX: "sm"
  }, toasts.map(function (_ref) {
    var id = _ref.id,
        toastProps = _objectWithoutPropertiesLoose(_ref, _excluded);

    return ___EmotionJSX(Toast, _extends({
      key: id,
      onClose: function onClose() {
        return closeToast(id);
      },
      onRemove: function onRemove() {
        return removeToast(id);
      }
    }, toastProps));
  }));
}